import http from 'src/services/http'

export const fetchCurrencyRate = async() => {
  const response = await http('globalSettings/currencyRate', {
    method: 'GET',
  })
  return response?.data
}
